// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__15tKJ","infoWrapper":"styles_infoWrapper__1rG_5","info":"styles_info__wbLkr","timeTable":"styles_timeTable__3XJGi"};